import React from "react";
import { useSelector } from "react-redux";
import { parseInt2 } from "../utils/functions";

const Withhold = () => {
  const withhold = useSelector((state) =>
    parseInt2(state.login.user.withholdAmount)
  );
  const token = useSelector((state) => state.login.token);
  return token && withhold > 0 ? (
    <div style={{ color: "#12abe8", fontSize: 20 }}>
      Withhold amount: SGD: {withhold}
      <br />
      Withhold Status: Processing
    </div>
  ) : null;
};

export default Withhold;
